import { useAtomValue } from 'jotai';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { LAUNCHDARKLY_TOGGLES } from '@studio/constants/launchdarkly-toggle-constants';
import { authenticationOpaPermissionsAtom } from '@studio/storeV2/authentication';
import Permissions from '@studio/constants/permissions';
import OpaPermissions from '@studio/constants/opa-permissions';
import { useSession } from '@studio/storeV2/authentication/session-store';

const useIsHardwareAdmin = (): boolean => {
  const hardwareAdminPerms = [
    Permissions.HARDWARE_OPTIONS_UPDATE,
    Permissions.HARDWARE_ORDERS_GET,
    Permissions.HARDWARE_UNITS_GET,
    Permissions.HARDWARE_UNITS_DASHBOARD,
    Permissions.HARDWARE_MONITORING_GET,
  ];
  const hardwareAdminOpaPerms = [OpaPermissions.HARDWARE_UPDATE, OpaPermissions.HARDWARE_READ];

  const { capabilities } = useSession();
  const { data: opaPermissions } = useAtomValue(authenticationOpaPermissionsAtom);
  const { [LAUNCHDARKLY_TOGGLES.OPA_MIGRATION]: opaMigration } = useFlags();

  if (opaMigration) {
    if (!opaPermissions) return false;

    if (opaPermissions.includes(OpaPermissions.SUDO_ADMIN)) return false;
    if (opaPermissions.includes(OpaPermissions.SUDO)) return false;

    return hardwareAdminOpaPerms.every((permission) => opaPermissions.includes(permission));
  }

  if (capabilities?.includes(Permissions.SUDO_ADMIN)) return false;
  if (capabilities?.includes(Permissions.SUDO)) return false;

  if (!capabilities) return false;

  return hardwareAdminPerms.every((permission) => capabilities.includes(permission));
};

export default useIsHardwareAdmin;
